import React, { Component } from "react";
import { getLanguageFlag } from "../languages/languages";
import { supportedLanguages } from "../settings";

export default class Header extends Component {
  state = {
    langListOpen: false,
  };

  handleLangList = () => {
    this.setState({ langListOpen: !this.state.langListOpen });
  };

  handleLangSelect = (lang) => {
    this.setState({ langSelectOpen: false });
    if (lang === this.props.globalState.language) return;
    this.props.langHandler(lang);
  };

  render() {
    return (
      <div className="header relative">
        <a
          href="/"
          className="svg-div-logo"
          style={{ cursor: "pointer", margin: "5px 0 30px" }}
        >
          <img width={80} src="./static/img/ghalichin-logo.svg" />
        </a>
      </div>
    );
  }
}
